{
  "actions": "Veiksmai",
  "hideButtonLabel": "Rodyti mažiau",
  "noTags": "Nėra",
  "showAllButtonLabel": "Rodyti viską ({tagCount, number})"
}
